export const roleDivisionMapping = {
    columns:[
        {headerName:"Level",mappedValue:"level"},
        {headerName:"User Hierarchy",mappedValue:"divisionName"},
        {headerName:"Parent",mappedValue:"parent"},
        {headerName:"Permission Group",mappedValue:"permissionGroups"},//array
        {headerName:"Role",mappedValue:"roleAccessType"},
        {headerName:"Channel",mappedValue:"channelDivision"},
    ],
    Actions:[
        "Update",
        "Delete",
        // "ChangeStatus"
    ]
}
export const divisionBulkUploadMapping = {
    columns:[
        {headerName:"User Hierarchy",mappedValue:"userhierarchy"},
        {headerName:"Parent",mappedValue:"reportinghierarchy"},
        {headerName:"Permission Group",mappedValue:"permissiongroups"},//array
        {headerName:"Channel",mappedValue:"ischannel"},
        {headerName:"Reason",mappedValue:"reason"},
    ],
    Actions:[
        "Update",
        "Delete",
        // "ChangeStatus"
    ]
}